<template lang="pug">

.app-card.overflow-x-auto.services-styled-panel
  .d-flex(class='justify-end tw-mb-3')
    edit-service-modal(
      :data-icon='"fa-solid fa-plus"'
      :data-mode='"new"'
      :data-item='JSON.stringify([])'
      @updated='createNewService'
      :data-label="$I18n.t('vue.services_detail_table_panel.title')"
    )

  //- Resumen de servicios
  .tw-flex.tw-items-center.tw-gap-4.tw-mb-3.tw-text-sm(v-if='!emptyItems')
    span.tw-text-gray-600
      i.fa-solid.fa-concierge-bell.tw-text-purple-500.tw-mr-1
      strong {{items.length}}
      |  service(s)
    span.tw-text-green-600.tw-font-medium
      i.fa-solid.fa-dollar-sign.tw-mr-1
      | Total: ${{calculateTotal()}}

  table(v-if='!emptyItems' class="table services-styled-table")
    thead
      tr
        th.tw-bg-gray-50(colspan="2")
        th.tw-bg-purple-50.tw-text-center(colspan="2")
          i.fa-solid.fa-clock.tw-mr-1
          | Schedule
        th.tw-bg-green-50.tw-text-center(colspan="3")
          i.fa-solid.fa-dollar-sign.tw-mr-1
          | Pricing
        th
      tr.tw-text-xs
        th.tw-text-gray-500.tw-w-10 #
        th
          i.fa-solid.fa-concierge-bell.tw-mr-1.tw-text-gray-400
          | Service
        //- Schedule
        th.tw-bg-purple-50.tw-border-l.tw-text-center
          i.fa-solid.fa-repeat.tw-mr-1.tw-text-purple-400
          | Frequency
        th.tw-bg-purple-50.tw-border-r.tw-text-center Breakdown
        //- Pricing
        th.tw-bg-green-50.tw-border-l.tw-text-center Base Price
        th.tw-bg-green-50.tw-border-r.tw-text-center.tw-font-medium Total
        th.tw-text-center.tw-w-24 Actions
    tbody
      tr(v-for="(item, index) in items" :key="item.id" class="hover:tw-bg-purple-50")
        //- Número
        td.tw-text-gray-400.tw-text-xs.tw-text-center {{index + 1}}
        //- Service
        td
          .tw-flex.tw-items-center
            .tw-w-8.tw-h-8.tw-rounded.tw-bg-purple-100.tw-flex.tw-items-center.tw-justify-center.tw-mr-2
              i.fa-solid.fa-concierge-bell.tw-text-purple-500.tw-text-sm
            span.tw-font-medium {{item.service}}
        //- Frequency
        td.tw-bg-purple-50.tw-bg-opacity-30.tw-border-l.tw-text-center
          span(class="tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-bg-purple-100 tw-text-purple-700")
            | {{formatFrequency(item)}}
        //- Breakdown
        td.tw-bg-purple-50.tw-bg-opacity-30.tw-border-r.tw-text-center
          span.tw-text-sm.tw-text-gray-600(v-if="item.breakdown") {{item.breakdown}}
          span.tw-text-gray-300(v-else) -
        //- Base Price
        td.tw-bg-green-50.tw-bg-opacity-30.tw-border-l.tw-text-center
          span.tw-text-gray-600 {{item.base_price}}
        //- Total
        td.tw-bg-green-50.tw-bg-opacity-30.tw-border-r.tw-text-center
          span.tw-font-bold.tw-text-green-600 ${{(item.total*100/100).toFixed(2)}}
        //- Actions
        td.tw-text-center
          .tw-flex.tw-gap-1.tw-justify-center
            edit-service-modal(
              :data-icon='"fa-solid fa-pencil"'
              :data-label='""'
              :data-mode='"edit"'
              :data-item='JSON.stringify(item)'
              @updated='updateService'
            )
            delete-service-modal(
              :data-id='item.id'
              :data-related-orders='item.orders_for_this_service'
              @deleted='deleteService'
            )

  div
    .tw-text-center.tw-py-8.tw-text-gray-500(v-if='emptyItems')
      i.fa-solid.fa-concierge-bell.tw-text-3xl.tw-text-gray-300.tw-mb-2
      p.tw-mt-2 {{$I18n.t('vue.services_detail_table_panel.empty_items')}}

</template>
<script>

import DeleteServiceModal from './delete-service-modal.vue'
import EditServiceModal from './edit-service-modal.vue'
import {BackendService} from '../../services';
import CoreComponents from '../core';
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';

export default {
  mixins: [StickyTableMixin],
  components:{
    'delete-service-modal':DeleteServiceModal,
    'edit-service-modal':EditServiceModal,
    "app-icon-btn": CoreComponents.AppIconBtn,
  },
  props:{
    dataId: String,
    dataModel: String,
    dataItems: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      record:{
        id: this.dataId,
      },
      items: JSON.parse(this.dataItems),
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    formatFrequency: function(item) {
      if (item.frequency_month && item.frequency_month !== "") {
        return item.frequency_month + ' mo';
      }
      return item.frequency + 'd';
    },
    calculateTotal: function() {
      return this.items.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0).toFixed(2);
    },
    retrieveServices:function(){
      location.reload();
    },
    createNewService:function(item){
      const self = this;
      this.state.sending = true;
      let params = JSON.stringify({
        id: this.dataId,
        service: JSON.parse(item)
      })
      BackendService
        .create_subsidary_service(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    deleteService:function(service_id){
      const self = this;
      this.state.sending = true;
      BackendService
        .service_delete(service_id)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    updateService:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .service_update(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
  }
}
</script>

<style scoped>
.services-styled-panel {
  padding: 1rem;
}

.services-styled-table {
  font-size: 0.85rem;
}

.services-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.services-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-border-l {
  border-left: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-border-r {
  border-right: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
</style>
